import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

export const FETCH_ONLINE_USAGE_REQUEST = 'FETCH_ONLINE_USAGE_REQUEST';
export const FETCH_ONLINE_USAGE_SUCCESS = 'FETCH_ONLINE_USAGE_SUCCESS';
export const FETCH_ONLINE_USAGE_FAILURE = 'FETCH_ONLINE_USAGE_FAILURE';

const buildOnlineUsageUrl = (groupId) => buildUrl(`/groups/${groupId}/fr-online-usage`);


export function fetchOnlineUsageIfNeeded(groupId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: buildOnlineUsageUrl(groupId) })) {
      return false;
    }
    return dispatch(fetchOnlineUsage(groupId));
  };
}

export function fetchOnlineUsage(groupId) {
  return (dispatch) => {
    const method = 'GET';
    const url = buildOnlineUsageUrl(groupId);
    return dispatch(fetchOnlineUsageRequest()).payload
      .then((response) => dispatch(fetchOnlineUsageSuccess(response)))
      .catch((error) => dispatch(fetchOnlineUsageFailure(error)));

    function fetchOnlineUsageRequest() {
      return ApiCall.createAction({
        type: FETCH_ONLINE_USAGE_REQUEST,
        payload: fetch(url),
        url,
        method,
      });
    }

    function fetchOnlineUsageSuccess(response) {
      return ApiCall.createAction({
        type: FETCH_ONLINE_USAGE_SUCCESS,
        payload: response,
        url,
        method,
        groupId,
      });
    }

    function fetchOnlineUsageFailure(error) {
      return ApiCall.createAction({
        type: FETCH_ONLINE_USAGE_FAILURE,
        error,
        url,
        method,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/OnlineUsage/actions.js